/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Drop_Frame_HelpInputs */

const en_embed_captions_drop_frame_help = /** @type {(inputs: Embed_Captions_Drop_Frame_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use drop frame timecode`)
};

const fr_embed_captions_drop_frame_help = /** @type {(inputs: Embed_Captions_Drop_Frame_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utiliser le timecode drop frame`)
};

const de_embed_captions_drop_frame_help = /** @type {(inputs: Embed_Captions_Drop_Frame_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwenden Sie Drop-Frame-Timecode.`)
};

const it_embed_captions_drop_frame_help = /** @type {(inputs: Embed_Captions_Drop_Frame_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizza il timecode drop frame`)
};

const ru_embed_captions_drop_frame_help = /** @type {(inputs: Embed_Captions_Drop_Frame_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Используйте временной код для пропуска кадров.`)
};

const es_embed_captions_drop_frame_help = /** @type {(inputs: Embed_Captions_Drop_Frame_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar código de tiempo de eliminación de fotogramas`)
};

const zh_cn2_embed_captions_drop_frame_help = /** @type {(inputs: Embed_Captions_Drop_Frame_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用丢帧时间码`)
};

const ja_embed_captions_drop_frame_help = /** @type {(inputs: Embed_Captions_Drop_Frame_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドロップフレームタイムコードを使用する`)
};

const hi_embed_captions_drop_frame_help = /** @type {(inputs: Embed_Captions_Drop_Frame_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ड्रॉप फ्रेम टाइमकोड का उपयोग करें`)
};

const pt_pt2_embed_captions_drop_frame_help = /** @type {(inputs: Embed_Captions_Drop_Frame_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use o código de tempo drop frame.`)
};

/**
* | output |
* | --- |
* | "Use drop frame timecode" |
*
* @param {Embed_Captions_Drop_Frame_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_drop_frame_help = /** @type {((inputs?: Embed_Captions_Drop_Frame_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Drop_Frame_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_drop_frame_help(inputs)
	if (locale === "de") return de_embed_captions_drop_frame_help(inputs)
	if (locale === "it") return it_embed_captions_drop_frame_help(inputs)
	if (locale === "ru") return ru_embed_captions_drop_frame_help(inputs)
	if (locale === "es") return es_embed_captions_drop_frame_help(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_drop_frame_help(inputs)
	if (locale === "ja") return ja_embed_captions_drop_frame_help(inputs)
	if (locale === "hi") return hi_embed_captions_drop_frame_help(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_drop_frame_help(inputs)
	return en_embed_captions_drop_frame_help(inputs)
});